import React from "react";
import { NavLink } from "react-router-dom";
import {useRecoilState} from 'recoil'
import { showMenu, aboutUs } from '@atoms';
import { useSecondModal } from "@helpers/hooks/useSecondModal";
import useWindowDimensions from "@helpers/hooks/windowDemensions";
import MenuOverlay from "@shared/MenuOverlay";

const PaymentSuccessHeader = () => {
  const [menuShow, setMenuShow] = useRecoilState(showMenu);
  const [, setAboutUs] = useRecoilState(aboutUs);
  const modal = useSecondModal();
  const { width } = useWindowDimensions();

  // Desktop: lay the header out full-width like the homepage (whatsapp left / menu right
  // at the screen edges). Mobile keeps the centered 600px column.
  const isDesktop = width > 767;
  const containerStyle = isDesktop ? {} : { maxWidth: '37.5rem', margin: '0 auto', paddingLeft: '1.25rem', paddingRight: '1.25rem' };
  const rowStyle = isDesktop ? {} : { marginLeft: 0, marginRight: 0 };
  const colStyle = isDesktop ? {} : { paddingLeft: 0, paddingRight: 0 };

  const menushow = () => {
    setMenuShow(true);
  };
  setTimeout(() => {
  }, 1000);

  const handelHeaderLinkToHome = () => {
    window.location.href = '/';
  };
  
  const handleAboutUsModal = (type) => {
    setAboutUs(type)
    if (width > 768) {
      modal('open', 'aboutUs')
    } else {
      modal('open', 'aboutUsMobile');
    }
  }

  return (
    <>
      <link rel="stylesheet" href="assets/css/style.css"></link>
      <MenuOverlay isVisible={menuShow} />
      <header className="payment-success-header fixed-top" style={{ position: 'fixed', top: '0px', left: '0px', right: '0px', zIndex: 98 }}>
            <div className="container-fluid" style={containerStyle}>
              <div className="row align-items-center" style={rowStyle}>
                <div className="col-2 col-md-4 order-md-1 text-left" style={colStyle}>
                  { width > 767 ? (
                      <img
                          class="whatsappimgdesk"
                          src="/assets/images/wtsap.svg"
                          alt=""
                          onClick={() => {
                            modal('open', 'whatsApp');
                          }}
                          style={{cursor: "pointer", paddingLeft: 0, paddingRight: 0}}
                      />
                  ) : (
                      <></>
                  )}
                  { width < 767 ? (
                      <img
                          class="whatsappimgmobile"
                          src="/assets/images/wtsap.svg"
                          alt=""
                          onClick={() => {
                            modal('open', 'whatsAppMobile');
                          }}
                          style={{cursor: "pointer", paddingLeft: 0, paddingRight: 0}}
                      />
                  ) : (
                      <></>
                  )}
                </div>

                <div className="col-8 col-md-4 text-center text-md-center order-md-2" style={colStyle}>
                    { width > 767 ? (
                        <img src="/assets/images/stk_logo.svg" alt="" />
                    ) : (
                        <img src="/assets/images/stk_logo.svg" alt="" />
                    )}
                </div>
                <div className="col-2 col-md-4 text-right order-md-3" style={colStyle}>
                  { width > 767 ? (
                      <span id="menu-wrap--notif" className="ps-menu-notif">
                        <img
                            src="/assets/images/bar.svg"
                            alt=""
                            id="menu"
                            onClick={() => {
                              menushow();
                            }}
                            style={{paddingLeft: 0, paddingRight: 0}}
                        />
                      </span>
                  ) : (
                      <span id="menu-wrap--notif" className="ps-menu-notif">
                        <img
                            src="/assets/images/bar.svg"
                            alt=""
                            id="menu"
                            onClick={() => {
                              menushow();
                            }}
                            style={{paddingLeft: 0, paddingRight: 0}}
                        />
                      </span>
                  )}
                </div>
              </div>
            </div>
          </header>
          <div className="menu" style={{ right: menuShow ? '0' : '-100%' }}>
            <div className="menu-head text-center">
              <img src="/assets/images/stk_logo.svg" alt="בלנדס"/>
           </div>
            <div className="menu-items">
            <ul style={{ display: "grid", direction: "rtl"}}>
              <li style={{marginBottom: "0px"}} onClick={() => {
                setMenuShow(false);
                const paModal = width > 767 ? 'personalArea' : 'personalAreaMobile';
                modal('open', paModal);
              }}>
                <span className="menu-icon-wrap menu-icon-wrap--1 menu-icon-wrap--notif">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#087E63" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                </span>
                <span className="menu-link--personal" style={{cursor: 'pointer'}}>אזור אישי</span>
              </li>
              <li style={{marginBottom: "0px"}}>
                <span className="menu-icon-wrap menu-icon-wrap--2">
                  <img src="/assets/images/inmenuwtsap.png" alt="" />
                </span>
                <span onClick={() => {
                            modal('open', 'whatsApp');
                          }}>דברו איתנו בוואצאפ</span>
              </li>
              <li style={{marginBottom: "0px"}} onClick={() => handleAboutUsModal('CQ')}>
                <span className="menu-icon-wrap menu-icon-wrap--3">
                  <img src="/assets/images/inmenufaq.png" alt="" />
                </span>
                <span>שאלות נפוצות</span>
              </li>
              <li className="in-menu-howto" style={{marginBottom: "0px"}} onClick={() => handleAboutUsModal('HT')}>
                <span className="menu-icon-wrap menu-icon-wrap--4">
                  <img src="/assets/images/inmenuhowto.png" alt="" />
                </span>
                <span>כיצד לרכוש בבלנדס</span>
              </li>
              <li style={{marginBottom: "0px"}}>
                <span className="menu-icon-wrap menu-icon-wrap--5">
                  <img src="/assets/images/inmenu-gift.png" alt="" />
                </span>
                <NavLink to="/business-gifts/hello" onClick={() => setMenuShow(false)} style={{color: 'inherit', textDecoration: 'none'}}>
                  <span>מתנות לעובדים</span>
                </NavLink>
              </li>
              <li className="menu-divider" aria-hidden="true"></li>
              <li style={{marginBottom: "0px"}}>
                <span className="menu-icon-wrap menu-icon-wrap--6">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#087E63" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="8" width="18" height="12" rx="2.5"/>
                    <line x1="12" y1="8" x2="12" y2="20"/>
                    <path d="M12 8c0-2.2-1-3.5-2.6-3.5-1.1 0-1.8.8-1.8 1.7C7.6 7.4 9.2 8 12 8Z"/>
                    <path d="M12 8c0-2.2 1-3.5 2.6-3.5 1.1 0 1.8.8 1.8 1.7C16.4 7.4 14.8 8 12 8Z"/>
                  </svg>
                </span>
                <NavLink to="/gift-card" onClick={() => setMenuShow(false)} style={{color: 'inherit', textDecoration: 'none'}}>
                  <span>רכישת גיפט קארד</span>
                </NavLink>
              </li>
              <li style={{marginBottom: "0px"}}>
                <span className="menu-icon-wrap menu-icon-wrap--7">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#087E63" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="7" height="7" rx="1.5"/>
                    <rect x="14" y="3" width="7" height="7" rx="1.5"/>
                    <rect x="3" y="14" width="7" height="7" rx="1.5"/>
                    <rect x="14" y="14" width="7" height="7" rx="1.5"/>
                  </svg>
                </span>
                <NavLink to="/products" onClick={() => setMenuShow(false)} style={{color: 'inherit', textDecoration: 'none'}}>
                  <span>קטלוג קירות</span>
                </NavLink>
              </li>
            </ul>
            </div>
            <div className="in-menu-button">
            <NavLink to='/upload-your-image'>
              <button onClick={{ right: menuShow ? '0' : '-100%' }}>עצבו קיר משלכם</button>
              </NavLink>
            </div>
            <div
              style={{
                position: "absolute",
                bottom: "1.28125rem",
                textAlign: "center",
                width: "22.5rem",
                paddingRight: "5.5em"
              }}
            >
              <div className="in-menu-social-icons" style={{marginBottom: "0.75rem"}}>
                <a href="https://www.facebook.com/profile.php?id=100086212847385" target="_blank" rel="noreferrer">
                  <img src="/assets/images/inmenufacebook.png" alt="הפייסבוק של בלנדס"/>
                </a>
                
                <a href="https://www.instagram.com/blends_il/" target="_blank" rel="noreferrer">
                  <img src="/assets/images/inmenuinstagram.png" alt="האינסטגרם של בלנדס"/>
                </a>
                
                <a href="https://www.tiktok.com/@blends_il" target="_blank" rel="noreferrer">
                  <img src="/assets/images/inmenutiktok.png" alt="הטיקטוק של בלנדס"/>
                </a>
              </div>
              <span style={{fontSize: "0.875rem", color: "#C8C8C8", fontWeight: "300", lineHeight: "2.25rem", textDecorationLine: "underline"}} onClick={() => handleAboutUsModal('AS')}>הצהרת נגישות</span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span style={{fontSize: "0.875rem", color: "#C8C8C8", fontWeight: "300", lineHeight: "2.25rem", textDecorationLine: "underline"}} onClick={() => handleAboutUsModal('PP')}>מדיניות פרטיות</span>
            </div>
          </div>
    </>
  );
}

export default PaymentSuccessHeader;